import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { Reveal, Lines, SectionTag } from "../site/Motion";
import { IMG } from "../../lib/images";

const SPECS = [
  ["Larghezza", "1009 mm"],
  ["Lunghezza", "2529 mm"],
  ["Altezza", "1424 mm"],
  ["Passo", "1730 mm"],
];

export function Dimensions() {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section id="dimensioni" data-testid="dimensions-section" ref={ref} className="theme-dark relative overflow-hidden border-t border-white/10 py-28 sm:py-40">
      <motion.div className="absolute inset-0" style={reduce ? {} : { y: imgY }}>
        <img src={IMG.dimensions} alt="Strada urbana di notte" className="h-[120%] w-full object-cover opacity-40" loading="lazy" />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/70 to-ink" aria-hidden="true" />

      <div className="relative mx-auto max-w-[1600px] px-5 sm:px-10">
        <SectionTag index="04" label="Dimensioni urbane" />
        <h2 className="mt-10 font-display font-extrabold uppercase leading-[0.92] tracking-tight">
          <Lines lines={["1009 mm."]} className="text-[13vw] text-white sm:text-7xl lg:text-8xl" />
          <Lines lines={["That changes everything."]} delay={0.15} className="text-2xl text-zinc-400 sm:text-4xl lg:text-5xl" />
        </h2>
        <Reveal delay={0.25} className="mt-8 max-w-xl">
          <p className="text-base leading-relaxed text-zinc-400">
            Un metro di carrozzeria. SWAPA attraversa la città con l'agilità di un oggetto
            progettato per il suo ecosistema: ingombro minimo, manovre semplici,
            parcheggio negli spazi che gli altri lasciano vuoti.
          </p>
        </Reveal>
        <div className="mt-16 grid grid-cols-2 gap-px bg-white/10 lg:grid-cols-4">
          {SPECS.map(([label, value], i) => (
            <Reveal key={label} delay={i * 0.1} className="bg-ink/90 p-6 backdrop-blur-sm sm:p-8">
              <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-500">{label}</p>
              <p className="mt-3 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">{value}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
